import { Component, OnChanges, Input, ViewChild } from "@angular/core";
import * as Moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";

@Component({
	selector: "app-mech-alerts",
	templateUrl: "./mech-alerts.component.html",
	styleUrls: ["./mech-alerts.component.scss"]
})
export class MechAlertsComponent implements OnChanges {
	@ViewChild("ackNoteModal") public ackNoteModal: any;

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public alerts: APIResults.Alert[];

	public totalAlerts = 0;
	public alertCurrentPage = 1;
	public alertItemsPerPage = 10;

	public acknowledgingAlert: number;
	public acknowledgeModalVisible = false;
	public acknowledgingNote: string;

	constructor(public api: ApiService, private modalService: NgbModal) { }

	async ngOnChanges() {
		await this.alertUpdatePage();
	}

	async alertUpdatePage() {
		const result = await this.api.GetAlerts(this.asset.asset_id, this.alertItemsPerPage * (this.alertCurrentPage - 1), this.alertItemsPerPage);
		const flattened = DvsUtilities.FlattenComponents(this.components);
		for (const row of result.rows) {
			if (row.component_key) {
				const comp = flattened.find(item => item.id === row.component_key);
				if (comp) {
					row.component_name = comp.name + " (" + comp.id + ")";
				}
			}
		}
		this.totalAlerts = result.count;
		this.alerts = result.rows;
	}

	async PromptAcknowledge(id: number) {
		this.acknowledgingAlert = id;
		this.modalService.open(this.ackNoteModal);
	}

	async AcknowledgeAlert() {
		await this.api.UpdateAlertAck(this.asset.asset_id, this.acknowledgingAlert, this.acknowledgingNote, true);
		this.asset.alertcount--;
		await this.alertUpdatePage();
		this.acknowledgingAlert = undefined;
		this.acknowledgingNote = undefined;
		this.modalService.dismissAll();
	}

	async UnacknowledgeAlert(id: number) {
		await this.api.UpdateAlertAck(this.asset.asset_id, id, null, false);
		this.asset.alertcount++;
		await this.alertUpdatePage();
	}

	async DeleteAlert(id: number) {
		await this.api.DeleteAlert(this.asset.asset_id, id);
		this.asset.alertcount--;
		await this.alertUpdatePage();
	}

	async ExportAlerts() {
		await this.api.ExportAlerts(this.asset.asset_name + "_" + Moment().format("YYYY-MM-DD HHmmss") + "_Alerts.csv", this.asset.asset_id);
	}

	async AcknowledgeAll() {
		await this.api.AcknowledgeAllAlerts(this.asset.asset_id);
		this.asset.alertcount = 0;
		await this.alertUpdatePage();
	}
}
